let timer;
const debounceFn = (fn, duration) => {
  clearTimeout(timer);
  timer = setTimeout(fn, duration);
};

export default debounceFn;
